<template lang="html">
<div class="sidebar-wrapper">
  <!-- Nav Links -->
  <nav class="sidebar" :style="{ visibility, left }">
    <div class="sidebar-item">
      <p>{{ tagline }}</p>
    </div>

    <router-link class="sidebar-nav-item" to="/">Home</router-link>
    <router-link class="sidebar-nav-item" to="/artworks">Artworks</router-link>
    <router-link class="sidebar-nav-item" to="/about">About</router-link>

    <div class="sidebar-admin" v-if="isLoggedIn">
      <router-link class="sidebar-nav-item" to="/admin">Admin</router-link>
    </div>

    <a class="sidebar-nav-item" :href="`mailto:${ email }?subject=${ email_question }`">Email</a>

    <div class="sidebar-item">
      <p>
        &copy; {{ title }}, {{ year }}.
      </p>
    </div>
  </nav>


</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'sidebar',
  props: {
    width: {
      type: Number,
      required: false,
      default: 250
    },
    open :{
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      required: false,
      default: 'left',
      validator: (value) => ['left', 'right'].indexOf(value) > -1
    }
  },
  data() {
    return {
      year : (new Date).getFullYear(),
      isLoggedIn : true,
      checked : false
    }
  },
  computed: {
    visibility() {
      return this.open ? 'visible' : 'hidden'
    },
    left() {
      return this.open ? 0 : '-14em'
    },
    ...mapState('config', ['email', 'email_question', 'title', 'tagline'])
  }
}
</script>

<style lang="scss" scoped>

/* Menu colors */
$menu-background: #3b889A;
$menu-text: #FFFFFF;
$menu-text-hover: #E0E0E0;

$primary-color: #999999;

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: -14rem;
  width: 14rem;
  visibility: hidden;
  overflow-y: auto;
  font-family: "PT Sans", Helvetica, Arial, sans-serif;
  // font-size: .875rem; /* 15px */
  color: rgba(255,255,255,.6);
  background-color: #202020;
}

@media (min-width: 30rem) {
  // .sidebar {
  //   font-size: .75rem; /* 14px */
  // }
}

.closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

/* Sidebar content */
.sidebar a {
  font-weight: normal;
  color: #fff;
}
.sidebar-item {
  padding: 1rem;
}
.sidebar-item p:last-child {
  margin-bottom: 0;
}

/* Sidebar nav */
.sidebar-nav {
  border-bottom: 1px solid rgba(255,255,255,.1);
}
.sidebar-nav-item {
  display: block;
  padding: .5rem 1rem;
  border-top: 1px solid rgba(255,255,255,.1);
}
.sidebar-nav-item.active,
a.sidebar-nav-item:hover,
a.sidebar-nav-item:focus {
  text-decoration: none;
  background-color: rgba(255,255,255,.1);
  border-color: transparent;
  color: $primary-color;
}

@media (min-width: 48rem) {
  .sidebar-item {
    padding: 1.5rem;
  }
  .sidebar-nav-item {
    padding-left:  1.5rem;
    padding-right: 1.5rem;
  }
}

/* Hide the sidebar checkbox that we toggle with `.sidebar-toggle` */
.sidebar-checkbox {
  display: none;
}

.sidebar-toggle-wrapper {
  position: absolute;
  top: 0;
  height: 100%;
}



/* Slide effect
 *
 * Handle the sliding effects of the sidebar and content in one spot, seperate
 * from the default styles.
 *
 * As an a heads up, we don't use `transform: translate3d()` here because when
 * mixed with `position: fixed;` for the sidebar toggle, it creates a new
 * containing block. Put simply, the fixed sidebar toggle behaves like
 * `position: absolute;` when transformed.
 *
 * Read more about it at http://meyerweb.com/eric/thoughts/2011/09/12/.
 */

.wrap,
.sidebar,
.sidebar-toggle {
    -webkit-backface-visibility: hidden;
       -moz-backface-visibility: hidden;
        -ms-backface-visibility: hidden;
            backface-visibility: hidden;
  -webkit-perspective: 1000;
     -moz-perspective: 1000;
      -ms-perspective: 1000;
          perspective: 1000;
}
.sidebar {
  -webkit-transition: all .3s ease-in-out;
     -moz-transition: all .3s ease-in-out;
      -ms-transition: all .3s ease-in-out;
          transition: all .3s ease-in-out;
}
.wrap,
.sidebar-toggle {
  -webkit-transition: left .3s ease-in-out;
     -moz-transition: left .3s ease-in-out;
      -ms-transition: left .3s ease-in-out;
          transition: left .3s ease-in-out;
}

#sidebar-checkbox:checked + .sidebar {
  left: 0;
  visibility: visible;
}
#sidebar-checkbox:checked ~ .wrap {
  left: 14rem;
}

</style>
